<template>
  <p class="checkbox-label w-full text-left">
    <slot />
  </p>
</template>
